import { downgradeInjectable } from '@angular/upgrade/static';
import { NetworkService } from 'src/ang2/app/core/network.service';

(function() {
  'use strict';

  angular.module('blocks.network')
    .service('NetworkService', downgradeInjectable(NetworkService));
})();
